module.exports = __webpack_public_path__ + "static/img/gn.b95b7a54.svg";